var map = {
	"./cloud-icon.svg": 515,
	"./letter-icon.svg": 516,
	"./list-icon.svg": 517,
	"./list2-icon.svg": 518,
	"./message-icon.svg": 519,
	"./pdf-icon.svg": 520,
	"./phone-icon.svg": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;